import request from '@/utils/request'

//国际卡列表
export function internationalCardList(data){
  return request({
    url: '/card/internationalPageCard',
    method: 'post',
    data: data
  })
}
// 获取国际资源列表
export function internationalSourcePage(data) {
  return request({
    url: '/internationalSource/page',
    method: 'post',
    data: data
  })
}

// 获取国际资源列表
export function internationalSourceList(data) {
  return request({
    url: '/internationalSource/list',
    method: 'get',
    params: data
  })
}

//保存运营商
export function internationalSourceSave(data) {
  return request({
    url: '/internationalSource/save',
    method: 'post',
    data: data
  })
}


//修改运营商
export function internationalSourceUpdate(data) {
  return request({
    url: '/internationalSource/update',
    method: 'post',
    data: data
  })
}

//根据资源找国家  multi
export function selectCountryBySourceId(data) {
  return request({
    url: '/internationalSource/selectCountry',
    method: 'get',
    params: data
  })
}

// 获取运营商列表
export function internationalOperatorPage(data) {
  return request({
    url: '/international/operator/page',
    method: 'post',
    data: data
  })
}

export function operatorList(data) {
  return request({
    url: '/operator/operatorList',
    method: 'get',
    params: data
  })
}

export function selectCountryOperators(data) {
  return request({
    url: '/sys/country/selectCountryOperators',
    method: 'post',
    data: data
  })
}

export function selectCountryByChannel(data) {
  return request({
    url: '/sys/country/selectByChannel',
    method: 'get',
    params: data
  })
}

//修改支付货币
export function updateCountry(data) {
  return request({
    url: '/sys/country/update',
    method: 'post',
    data: data
  })
}
//新增国家
export function addCountry(data) {
  return request({
    url: '/sys/country/add',
    method: 'post',
    data: data
  })
}

//获取州国家
export function selectContinentCountry(data) {
  return request({
    url: '/sys/country/selectContinent',
    method: 'get',
    params: data
  })
}

//修改运营商
export function operatorUpdate(data) {
    return request({
      url: '/operator/update',
      method: 'post',
      data: data
    })
}

//修改运营商
export function countryPage(data) {
    return request({
      url: '/sys/country/list',
      method: 'post',
      data: data
    })
}

//国家列表
export function countryList(data) {
    return request({
      url: '/sys/country/all',
      method: 'get',
      params: data
    })
}


//保存国际运营商
export function addInternationalProduct(data) {
  return request({
    url: '/international/product/addInternationalProduct',
    method: 'post',
    data: data
  })
}


//修改国际运营商
export function updateInternationalProduct(data) {
  return request({
    url: '/international/product/updateInternationalProduct',
    method: 'post',
    data: data
  })
}

//国际运营商详情查看
export function getInternationalProduct(data) {
  return request({
    url: '/international/product/getInternationalProduct',
    method: 'get',
    params: data
  })
}


//国际底价套餐新增
export function addBaseInternationalProduct(data) {
  return request({
    url: '/baseProduct/addBaseInternationalProduct',
    method: 'post',
    data: data
  })
}

//国际底价详情
export function baseInternationalProductInfo(data) {
  return request({
    url: '/baseProduct/baseInternationalProductInfo',
    method: 'get',
    params: data
  })
}

//国际底价修改
export function updateBaseInternationalProduct(data) {
  return request({
    url: '/baseProduct/updateBaseInternationalProduct',
    method: 'post',
    data: data
  })
}

//国际上级底价
export function baseParentInternationalProductInfo(data) {
  return request({
    url: '/baseProduct/baseParentInternationalProductInfo',
    method: 'get',
    params: data
  })
}


//国际上级底价
export function internationalFlowRecords(data) {
  return request({
    url: '/international/flow/page',
    method: 'post',
    data: data
  })
}

//国际话单导出
export function internationalFlowExport(data) {
  return request({
    url: '/international/flow/export',
    method: 'post',
    data: data
  })
}

export function internationalFlowSum(data) {
  return request({
    url: '/international/flow/selectFlow',
    method: 'post',
    data: data
  })
}


//国际语音话单列表
export function internationalVoiceRecords(data) {
  return request({
    url: '/international/voice/page',
    method: 'post',
    data: data
  })
}
//国际短信话单列表
export function internationalSmsRecords(data) {
  return request({
    url: '/international/sms/page',
    method: 'post',
    data: data
  })
}

export function openInterCard(data) {
    return request({
        url: '/international/cardInfo/open',
        method: 'post',
        data: data
    })
}

export function closeInterCard(data) {
    return request({
        url: '/international/cardInfo/close',
        method: 'post',
        data: data
    })
}

export function resetInteNetwork(data) {
    return request({
        url: '/international/cardInfo/resetNetwork',
        method: 'post',
        data: data
    })
}

// SIM卡发送短信
export function simInterSendSms(data) {
    return request({
        url: '/international/cardInfo/sendInterSms',
        method: 'post',
        data: data
    })
}
// SIM卡群发短信
export function simInterSendBatchSms(data) {
    return request({
        url: '/international/cardInfo/sendBatchInterSms',
        method: 'post',
        data: data
    })
}

// SIM卡已发短信记录
export function simInterSmsSentList(data) {
    return request({
        url: '/internationalSimSmsRecord/sentList',
        method: 'post',
        data: data
    })
}
export function simInterSmsReceivedList(data) {
    return request({
        url: '/internationalSimSmsRecord/receivedList',
        method: 'post',
        data: data
    })
}
//按钮激活流量套餐
export function mannualActiveFlow(data) {
    return request({
        url: '/international/cardInfo/activeFlow',
        method: 'post',
        data: data
    })
}
//按钮激活语音套餐
export function mannualActiveVoice(data) {
    return request({
        url: '/international/cardInfo/activeVoice',
        method: 'post',
        data: data
    })
}
//按钮激活短信套餐
export function mannualActiveSms(data) {
    return request({
        url: '/international/cardInfo/activeSms',
        method: 'post',
        data: data
    })
}

//同步国际套餐
export function syncInternationalProductExternal(data) {
  return request({
    url: '/international/productExternal/syncProduct',
    method: 'get',
    params: data
  })
}

//同步国际运营商
export function syncInternationalOperatorExternal(data) {
  return request({
    url: '/international/operatorExternal/syncInternationalOperatorExternal',
    method: 'get',
    params: data
  })
}


//同步国际运营商
export function productExternalPage(data) {
  return request({
    url: '/international/productExternal/page',
    method: 'post',
    data: data
  })
}

export function delProductExternal(data) {
  return request({
    url: '/international/productExternal/delProducts',
    method: 'post',
    data: data
  })
}


//查询所有国际套餐
export function productExternalList(data) {
  return request({
    url: '/international/productExternal/list',
    method: 'post',
    data: data
  })
}

export function internationalChannelCountryList(data) {
  return request({
    url: '/international/channel/country/list',
    method: 'get',
    params: data
  })
}

export function saveInternationalChannelCountry(data) {
  return request({
    url: '/international/channel/country/save',
    method: 'post',
    data: data
  })
}

//国际群组

export function internationalGroupList(data) {
  return request({
    url: '/international/group/page',
    method: 'post',
    data: data
  })
}

export function saveInternationalGroup(data) {
  return request({
    url: '/international/group/save',
    method: 'post',
    data: data
  })
}

export function updateInternationalGroup(data) {
  return request({
    url: '/international/group/update',
    method: 'post',
    data: data
  })
}

//查询群组
export function selectGroups(data) {
  return request({
    url: '/international/group/selectGroup',
    method: 'get',
    params: data
  })
}
//查询使用区域
export function selectGroupChannel(data) {
  return request({
    url: '/international/group/selectGroupChannel',
    method: 'get',
    params: data
  })
}
//根据键值查找
export function selectGroupCountry(data) {
  return request({
    url: '/international/group/selectCountry',
    method: 'get',
    params: data
  })
}

//查询群组详情
export function infoInternationalGroup(data) {
  return request({
    url: '/international/group/info',
    method: 'get',
    params: data
  })
}


//设置代理商自定义区域价格
export function updateUserInternationalProductPrice(data){
  return request({
    url: '/international/product/userInternationalProductPrice',
    method: 'post',
    data: data
  })
}

export function getUserInternationalProduct(data){
  return request({
    url: '/international/product/getUserInternationalProduct',
    method: 'get',
    params: data
  })
}



//卡自定义套餐
export function selectInternationalCardProductList(data){
  return request({
    url: '/international/cardProduct/page',
    method: 'post',
    data: data
  })
}

//单卡自定义区域以及区域价格
export function selectInternationalCardProduct(data){
  return request({
    url: '/international/cardProduct/selectInternationalCardProduct',
    method: 'get',
    params: data
  })
}
//保存卡自定义限制区域和价格
export function saveInternationalCardProduct(data){
  return request({
    url: '/international/cardProduct/saveInternationalCardProduct',
    method: 'post',
    data: data
  })
}

//移除卡限制区域以及套餐
export function removeInternationalCardProduct(data){
  return request({
    url: '/international/cardProduct/remove',
    method: 'get',
    params: data
  })
}
//运营商卡的国际套餐
export function internationalCardProductExternal(data){
  return request({
    url: '/international/cardProductExternal/list',
    method: 'post',
    data: data
  })
}
//同步国际流量卡运营商套餐
export function syncInternationalCardProductExternal(data){
  return request({
    url: '/international/cardProductExternal/sync',
    method: 'get',
    params: data
  })
}

//国际话单数据统计
export function lineChartCardSession(data){
  return request({
    url: '/statistic/lineChartCardSession',
    method: 'get',
    params: data
  })
}

//卡源运营商数据
export function internationalChnanelOperatorPage(data){
  return request({
    url: '/international/channel/operator/page',
    method: 'post',
    data: data
  })
}

//保存卡源运营商
export function internationalChnanelOperatorSave(data){
  return request({
    url: '/international/channel/operator/save',
    method: 'post',
    data: data
  })
}
//删除卡源运营商

export function internationalChnanelOperatorDel(params){
  return request({
    url: '/international/channel/operator/del',
    method: 'get',
    params
  })
}

//国家运营商数据
export function selectCountryOperator(data){
  return request({
    url: '/international/operator/selectCountryOperator',
    method: 'get',
    params: data
  })
}

//国际卡申请列表
export function internationalApplicationList(data){
  return request({
    url: '/simLogisticRecord/pageList',
    method: 'post',
    data: data
  })
}

//物流信息添加
export function submitSimLogistic(data){
  return request({
    url: '/simLogisticRecord/update',
    method: 'post',
    data: data
  })
}

//备注信息修改
export function updateSimLogisticRemark(data){
  return request({
    url: '/simLogisticRecord/updateRemark',
    method: 'post',
    data: data
  })
}

//国际卡申请详情
export function internationalApplicationInfo(data){
  return request({
    url: '/simLogisticRecord/info',
    method: 'get',
    params: data
  })
}

//卡申请订单列表
export function internationalApplicationOrderList(data){
  return request({
    url: '/simLogisticRecord/simOrderList',
    method: 'get',
    params: data
  })
}
//卡邮件发送列表
export function internationalMailRecordList(data){
  return request({
    url: '/simLogisticRecord/simMailList',
    method: 'get',
    params: data
  })
}
//分配卡
export function simDistribution(data){
  return request({
    url: '/simLogisticRecord/simDistribution',
    method: 'post',
    data: data
  })
}
//重新发送卡邮件
export function simSendEmail(data){
  return request({
    url: '/simLogisticRecord/simSendEmail',
    method: 'get',
    params: data
  })
}


//国际网络信息列表
export function internationalNetworkPage(data) {
  return request({
    url: '/international/network/page',
    method: 'post',
    data: data
  })
}

//保存国际网络信息
export function internationalNetworkSave(data) {
  return request({
    url: '/international/network/save',
    method: 'post',
    data: data
  })
}

//修改国际网络信息
export function internationalNetworkUpdate(data) {
  return request({
    url: '/international/network/update',
    method: 'post',
    data: data
  })
}

//修改国际网络信息状态
export function internationalNetworkChangeStatus(data) {
  return request({
    url: '/international/network/changeStatus',
    method: 'post',
    data: data
  })
}








